<template>
  <Rackman filled />

</template>

<script>
import Rackman from '@/components/Rackman'

export default {
  components: {
    Rackman
  }
}
</script>

<style>
</style>